import { render, staticRenderFns } from "./PlatformTypeSelect.vue?vue&type=template&id=0b43f596"
import script from "./PlatformTypeSelect.vue?vue&type=script&lang=js"
export * from "./PlatformTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports